import React from "react";
import { Button, Iconography, Modal } from "@hid-galaxy-ui/galaxy-react";
import { EngagementSubmission } from "../../../../../redux/slices/engagement-form/Types";
import { useNavigate } from "react-router";
import "./SubmissionDetailsModal.scss";

const SubmissionDetailsModal: React.FC<{
  submissionDetails: EngagementSubmission;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isEditable: boolean;
  showEditButton?: boolean;
  canEditSubmission?: boolean;
}> = ({
  submissionDetails,
  setModalOpen,
  isEditable,
  showEditButton = false,
  canEditSubmission = false,
}) => {
  const navigate = useNavigate();
  const sortedFields = [...submissionDetails.data].sort(
    (a, b) => a.sort_order - b.sort_order
  );

  const formatValues = (value: string | string[]) => {
    return Array.isArray(value) ? value.join(", ") : value || "-";
  };

  const handleEditClick = () => {
    if (!canEditSubmission) return;
    navigate(`/hid-admin/engagement-form/update/${submissionDetails.id}`);
  };

  return (
    <Modal
      headerText="Engagement Form Submission"
      width={700}
      onClose={() => setModalOpen(false)}
      className="engagement-submission-detail-modal"
    >
      <div className="submission-detail-container">
        {showEditButton && (
          <div className="edit-button-container">
            <Button
              variant="primary"
              label="Edit"
              onClick={handleEditClick}
              disabled={!canEditSubmission}
              icon={<Iconography icon="pen" />}
            />
          </div>
        )}
        <div className="detail-table">
          {sortedFields.map((field, index: number) => {
            return (
              <div
                className="table-row"
                style={index === 0 ? { borderTop: "none" } : {}}
                key={field.field_key}
              >
                <div className="label">{field.label}</div>
                {field.field_type === "inline" ? (
                  <div
                    className="value"
                    dangerouslySetInnerHTML={{
                      __html: formatValues(field.value),
                    }}
                  ></div>
                ) : (
                  <div className="value">{formatValues(field.value)}</div>
                )}
              </div>
            );
          })}
        </div>
        <div className="button-group">
          <Button
            variant="primary"
            label="Close"
            onClick={() => setModalOpen(false)}
          />
        </div>
      </div>
    </Modal>
  );
};

export default SubmissionDetailsModal;
